/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */

import axios from 'axios'

/* constants */
const AXEPTA_INIT_PAYMENT_BASE_URL = 'middle-bank-service/api/v2/payment/axepta/init-payment/'
const AXEPTA_EXECUTE_PAYMENT_BASE_URL = 'middle-bank-service/api/v2/payment/axepta/execute-payment/'

export function processAxeptaPayment(tunnelData, values, setAxeptaResponse, setHasAlreadyFailedCb, setPaymentButtonLock) {
  const token = tunnelData.access_token;
  const headers = {
    Authorization: `Bearer ${token}`,
    Accept: "*/*",
    "Content-Type": "application/json"
  };
  const payload = {
    cardNumber: values.cardNumber.replace(/\s/g, ''),
    cardExpiration: values.month + values.year.substring(2, 4),
    cardCvv: values.cvv
  }
  // init axepta payment
  axios.get(tunnelData.apiUrl + AXEPTA_INIT_PAYMENT_BASE_URL + tunnelData.opl, { headers: headers })
    .then(initResponse => {
      // execute payment
      axios.post(tunnelData.apiUrl + AXEPTA_EXECUTE_PAYMENT_BASE_URL + tunnelData.opl, payload, { headers: headers })
        .then(executeResponse => {
          setAxeptaResponse({ axeptaCardType: executeResponse.data.cardType, axeptaIframContent: executeResponse.data.iframeContent })
        })
        .catch(executeError => {
          setAxeptaResponse(null)
          setHasAlreadyFailedCb(true)
          setPaymentButtonLock(false)
        })
    })
    .catch(initError => {
      setAxeptaResponse(null)
      setHasAlreadyFailedCb(true)
      setPaymentButtonLock(false)
    })
}

export function handleAxeptaResponse(response, props, setHasAlreadyFailedCb, setAxeptaExecuteResponse) {
  if (response.data === 'axepta_SUCCESS_message') {
    setTimeout(() => props.onSetStep(), 2000)
  } else if (response.data !== 'axepta_3DS_CHALLENGE_message') {
    setTimeout(() => {
      setHasAlreadyFailedCb(true);
      setAxeptaExecuteResponse(null)
    }, 2000)

  }
  }